function getState(cardNumber) {
    return {
        type: "STORE_CARD",
        cardNumber
    }
}
export const storeCardDetail = (cardNumber) => dispatch => {
    dispatch(getState(cardNumber))

}


// WEBPACK FOOTER //
// ./src/actions/storecarddetail.jsx